module.exports = __webpack_public_path__ + "static/media/Engpic3@3x.c44195b2.png";